import styled from 'styled-components';
import { rgba } from 'polished';
import { theme } from '../../styles/config/theme';
import { typeStyle } from '../../styles/config/typeStyles';
import media from '../../styles/config/mediaQueries';

const StyledSection = styled.section`
  margin-bottom: 38px;
  padding-top: 36px;
`;

const StyledTabList = styled.ul`
  display: flex;
  margin-bottom: 20px;
  ${media.mobile`
    max-width: 100%;
    padding-bottom: 15px;
    overflow-x: auto;
    &::-webkit-scrollbar {
      width: 3px;
      height: 3px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: ${rgba(theme.color.gray, 0.5)};
      border-radius: 30px;
    }
  `}
  ${media.desktop`
    flex-wrap: wrap;
  `}
`;

const StyledTabItem = styled.li`
  margin: 0 6px 6px 0;
`;

const StyledTabButton = styled.button`
  padding: 4px 6px;
  transition: 0.25s ease-in-out;
  transition-property: background-color, color, border;
  background-color: ${props => (props.active ? theme.color.white : 'transparent')};
  color: ${props => (props.active ? theme.color.black : theme.color.white)};
  border: 1px solid transparent;
  border-color: ${props =>
    props.active ? rgba(theme.color.white, 1) : rgba(theme.color.white, 0.3)};
  border-radius: 50px;
  ${typeStyle.h5}
  text-transform: uppercase;
  letter-spacing: 0.3px;
  line-height: 15px;
`;

const StyledQuestionList = styled.ul`
  ${media.desktop`
    max-height: 300px;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      width: 3px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: ${rgba(theme.color.gray, 0.5)};
      border-radius: 30px;
    }
  `}
`;

const StyledContentItem = styled.li`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 18px;
  padding-left: 13px;
  ${typeStyle['font-14']}
  letter-spacing: 0.5px;

  &::before {
    content: '';
    position: absolute;
    top: 8px;
    left: 0;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    transform: translateY(-50%);
    background-color: ${theme.color.white};
  }
`;

const StyledLikeButton = styled.button`
  display: inline-block;
  width: 26px;
  height: 25px;
  margin-left: 5px;
  transform: translateY(-4px);
`;

const StyledTemporaryWrapper = styled.div`
  margin-left: -20px;
  margin-bottom: 30px;
`;

export {
  StyledSection,
  StyledTabList,
  StyledTabItem,
  StyledTabButton,
  StyledQuestionList,
  StyledContentItem,
  StyledLikeButton,
  StyledTemporaryWrapper,
};
